import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useSelector } from "react-redux";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import GlobalContext from "../../framework/GlobalContext";
import classes from "./ModeConfigPricingReport.module.css";
import ModeConfigPricingReportFilter from "./ModeConfigPricingReportFilter";
import ModeConfigPricingReportSummary from "./ModeConfigPricingReportSummary";
import ModeConfigPricingUpdateAutocomplete from "./ModeConfigPricingUpdateAutocomplete";

const ModeConfigPricingReport = () => {
  const [filterParams, setFilterParams] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const reportRef = useRef();
  const exportRef = useRef();
  const refreshRef = useRef();
  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const [filterStates, setFilterStates] = useState(null);
  const applyFilterOnMount = false;
  const [rackRowData, setRackRowData] = useState(null);

  const rackRef = useRef();

  const [showSetRackAutocomplete, setShowSetRackAutocomplete] = useState(false);
  const { data } = useSelector((state) => {
    return state.commonReducer.tabs[state.commonReducer?.activeTabIndex];
  });

  const refreshDataHandler = useCallback(
    (filterData = null) => {
      const appliedFilters = filterData || filterParams;
      if (!reportRef.current) return;
      if (appliedFilters) {
        reportRef.current.applyFilters({
          ...appliedFilters,
          isFilterChanged: false,
        });
        return;
      }
      reportRef.current.applyFilters({});
    },
    [filterParams]
  );

  const rackHandler = useCallback(() => {
    if (currentRowData) {
      setShowSetRackAutocomplete(true);
      setCurrentComponent("grid_set_rack");
      const rowData = data?.rows?.filter((row) => row.checked);
      const payload = [];
      if (rowData?.length) {
        payload.push(...rowData);
      } else {
        payload.push(currentRowData?.data);
      }
      setRackRowData(payload);
    }
  }, [currentRowData, setCurrentComponent]);

  const applyFilterHandler = useCallback((params, filterStates) => {
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);
  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        refreshRef.current.click();
        return;
      }
      if (altKey && key === "e") {
        exportRef.current.click();
        return;
      }
      if (ctrlKey && key === "u") {
        if (currentRowData?.data) rackRef?.current.click();
        return;
      }
    },
    [currentRowData]
  );
  const quickExportHandler = () => {
    reportRef?.current?.quickExport({ fileName: "ModeConfigPricingReport" });
  };
  useEffect(() => {
    if (!showSetRackAutocomplete) {
      setRackRowData(null);
    }
  }, [showSetRackAutocomplete]);
  useEffect(() => {
    if (!onFilterShow && !onColumnShow && currentComponent === "grid_reports")
      document.addEventListener("keyup", listener, false);
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow]);

  return (
    <div className={classes["mode-config-pricing-report-container"]}>
      <Reports
        reportRef={reportRef}
        identifier="modeConfigPricingReport"
        filterParams={filterParams}
        filterStates={filterStates}
        showFilterOnMount={true}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filters={
          <ModeConfigPricingReportFilter
            applyFilterOnMount={applyFilterOnMount}
            onFilterShow={onFilterShow}
            reportRef={reportRef}
            applyFilterHandler={applyFilterHandler}
          />
        }
        currentRow={setCurrentRowData}
      />
      <ModeConfigPricingReportSummary
        refreshData={refreshDataHandler}
        refreshRef={refreshRef}
        quickExport={quickExportHandler}
        exportRef={exportRef}
        rackHandler={rackHandler}
        rackRef={rackRef}
      />
      <Autocomplete
        show={showSetRackAutocomplete}
        width="100%"
        height="70%"
        closeAutoComplete={() => {
          setCurrentComponent("grid_reports");
          setShowSetRackAutocomplete(false);
        }}
      >
        <ModeConfigPricingUpdateAutocomplete
          rowData={rackRowData}
          onEscape={() => {
            setCurrentComponent("grid_reports");
            setShowSetRackAutocomplete(false);
          }}
          onSave={() => {
            setCurrentComponent("grid_reports");
            setShowSetRackAutocomplete(false);
            refreshDataHandler();
          }}
        />
      </Autocomplete>
    </div>
  );
};

export default ModeConfigPricingReport;
